import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import { Link } from 'react-router-dom';

const SearchContainer = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #0052CC 0%, #0747A6 100%)',
  padding: theme.spacing(4, 0),
  marginBottom: theme.spacing(4),
  color: 'white',
}));

const CompanyCard = styled(Card)(({ theme }) => ({
  height: '100%',
  cursor: 'pointer',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
  },
}));

const CompanyLogo = styled(Box)(({ theme }) => ({
  width: 80,
  height: 80,
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.grey[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

const mockCompanies = [
  {
    id: 1,
    name: 'Tech Corp',
    logo: 'TC',
    location: 'New York, NY',
    industry: 'Technology',
    size: '100-500 employees',
    description: 'Leading technology company specializing in innovative solutions...',
    openPositions: 5,
  },
  {
    id: 2,
    name: 'Design Studio',
    logo: 'DS',
    location: 'San Francisco, CA',
    industry: 'Design',
    size: '50-100 employees',
    description: 'Creative design studio focused on user experience...',
    openPositions: 3,
  },
  {
    id: 3,
    name: 'Finance Pro',
    logo: 'FP',
    location: 'Chicago, IL',
    industry: 'Finance',
    size: '500+ employees',
    description: 'Leading financial services provider...',
    openPositions: 8,
  },
  // Add more mock companies as needed
];

function CompaniesListPage() {
  return (
    <Box>
      <SearchContainer>
        <Container>
          <Typography variant="h4" gutterBottom>
            Find Great Companies
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                placeholder="Company name or keyword"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: 'primary.main' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{ bgcolor: 'white', borderRadius: 1 }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth variant="outlined" sx={{ bgcolor: 'white', borderRadius: 1 }}>
                <InputLabel>Industry</InputLabel>
                <Select label="Industry">
                  <MenuItem value="technology">Technology</MenuItem>
                  <MenuItem value="finance">Finance</MenuItem>
                  <MenuItem value="healthcare">Healthcare</MenuItem>
                  <MenuItem value="education">Education</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth variant="outlined" sx={{ bgcolor: 'white', borderRadius: 1 }}>
                <InputLabel>Location</InputLabel>
                <Select label="Location">
                  <MenuItem value="newyork">New York</MenuItem>
                  <MenuItem value="sanfrancisco">San Francisco</MenuItem>
                  <MenuItem value="chicago">Chicago</MenuItem>
                  <MenuItem value="remote">Remote</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                fullWidth
                variant="contained"
                size="large"
                sx={{ height: '56px' }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </Container>
      </SearchContainer>

      <Container>
        <Grid container spacing={3}>
          {mockCompanies.map((company) => (
            <Grid item xs={12} md={4} key={company.id}>
              <CompanyCard component={Link} to={`/companies/${company.id}`}>
                <CardContent>
                  <CompanyLogo>
                    <Typography variant="h4" color="primary">
                      {company.logo}
                    </Typography>
                  </CompanyLogo>
                  <Typography variant="h6" gutterBottom>
                    {company.name}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                    <Typography variant="body2" color="text.secondary">
                      <BusinessIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                      {company.industry}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <LocationOnIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                      {company.location}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <PeopleIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                      {company.size}
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {company.description}
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" color="primary.main">
                      {company.openPositions} open positions
                    </Typography>
                    <Button variant="outlined" size="small">
                      View Company
                    </Button>
                  </Box>
                </CardContent>
              </CompanyCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default CompaniesListPage; 